import { Editor } from '@tiptap/core';
import React from 'react';

import { Chip } from '@/ui/Chip';
import { TagOptions } from '@/ui/Editor/extensions/Tag/types';
import { Text } from '@/ui/Text';
import { useTranslation } from 'react-i18next';

interface TagListProps {
	editor: Editor | null;
	tags: TagOptions['availableTags'];
}

const TagList = (props: TagListProps) => {
	const { editor, tags } = props;

	const handleTagClick = (tag: string) => {
		editor?.chain().focus().setTag(tag).run();
	};

	const handleDragStart = (event: React.DragEvent, tag: string) => {
		event.dataTransfer.setData('tag', tag);
	};

	if (!editor) {
		return null;
	}

	const { t } = useTranslation();

	return (
		<div className="flex flex-col gap-2 mt-1">
			<Text variant="description">{t('editor.tag')}:</Text>
			<div className="flex flex-col gap-2">
				{tags.map((item) => (
					<div key={item.tag} className="flex gap-1">
						<Chip
							draggable
							onClick={() => handleTagClick(item.tag)}
							onDragStart={(event) => handleDragStart(event, item.tag)}
						>
							{item.tag}
						</Chip>
						<span>—</span>
						<span>{item.label}</span>
					</div>
				))}
			</div>
		</div>
	);
};

export { TagList };
